import type { UseFetchOptions } from '#app'
import { BACKEND_PREFIX } from '~/constant/request'

export function useAppFetch<T>(
  url: string,
  options: UseFetchOptions<T> = {},
) {
  const head = useCommonHead()
  return useFetch(url, {
    body: {
      head,
      ...(options?.body as object || {}),
    },
    ...options,
    onRequest({ options }) {
      const originalBody = options.body || {}
      const userInfoStore = useUserStore()
      const userInfo = userInfoStore.getRowUserInfo()
      if (typeof originalBody === 'object') {
        options.body = {
          ...originalBody,
          ...userInfo,
        }
      }
    },
  })
}

export function useBackendFetch<T>(
  url: string,
  options: UseFetchOptions<T> = {},
) {
  const head = useCommonHead()
  return useFetch(`${BACKEND_PREFIX}${url}`, {
    ...options,
    body: {
      // 添加用户信息
      ...useUserStore().getRowUserInfo(),
      head,
      ...(typeof options.body === 'object' ? options.body : {}),
    },
  })
}


export function useBackendSKU<T>(
  url: string,
  options: UseFetchOptions<T> = {},
) {
  return useFetch(url, {
    ...options,
    method: 'POST',  // Move method out if this is a standard way for requests
    headers: {
      'Content-Type': 'application/json',
      'Labrador-Token': '658348a8-44aa-42c7-af23-eb1ded037286',
      ...options.headers,  // Merge custom headers if provided
    },
    body: typeof options.body === 'object' ? JSON.stringify(options.body) : options.body,
  });
}

